export default __webpack_public_path__ + "static/media/clouds.89d43618.png";